<template>
  <v-container>

    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
            label="Reddit URL / Post ID"
            placeholder="https://redd.it/xyz"
            outlined
            v-model="imageOneId"
            @change="imageOneOneUpdate"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
            label="Reddit URL / Post ID"
            placeholder="https://redd.it/xyz"
            outlined
            v-model="imageTwoId"
            @change="imageTwoOnUpdate"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" md="5">
        <CompareImageHolder :image-hash="imageOneDif" :post="imageOne"></CompareImageHolder>
      </v-col>
      <v-col cols="12" md="2"><div class="text-h3 text-center" v-if="imageOne && imageTwo">{{percentDif}}%</div></v-col>
      <v-col cols="12" md="5">
        <CompareImageHolder :image-hash="imageTwoDif" :post="imageTwo"></CompareImageHolder>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {getPostIdFromUrl, hammingDistance} from "@/util/helpers";
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import CompareImageHolder from "@/components/compare/CompareImageHolder";
const PostRepo = RepositoryFactory.get('post')
const RepostRepo = RepositoryFactory.get('repost')

export default {
  name: "Compare",
  components: {CompareImageHolder},
  data: () => ({
    imageOneId: null,
    imageTwoId: null,
    imageOneDifHash: null,
    imageTwoDifHash: null,
    imageOne: null,
    imageTwo: null,
    comparisonResults: null,
    imageText: null
  }),
  methods: {
    getImageText() {
      console.log('Getting image text')
      RepostRepo.getImageText({image_one: this.imageOne.url, image_two: this.imageTwo.url}, null)
        .then(res => {
          console.log(res)
          this.imageText = res.data
        })
    },
    imageOneOneUpdate() {
      this.imageOneId = getPostIdFromUrl(this.imageOneId)
      this.imageTwoId = getPostIdFromUrl(this.imageTwoId)
      if (!this.imageOneId) {
        this.$emit('on-alert', {color: 'error', message: 'Unable to parse Post ID from provided URL'})
      } else {
        this.loadPost(this.imageOneId)
      }

    },
    imageTwoOnUpdate() {
      this.imageTwoId = getPostIdFromUrl(this.imageTwoId)
      if (!this.imageTwoId) {
        this.$emit('on-alert', {color: 'error', message: 'Unable to parse Post ID from provided URL'})
      } else {
        this.loadPost(this.imageTwoId)
      }

    },
    loadPost(postId) {
      PostRepo.getSleuthPost({post_id: postId}, null)
        .then(res => {
          console.log(res)
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
          } else {
            if (this.imageOneId === res.data.post_id) {
              this.imageOne = res.data
            } else {
              this.imageTwo = res.data
            }
          }
        })
    },
    difHashes(hashOne, hashTwo) {
      let result = '';
      hashOne.split('').forEach(function (val, i) {
        if (val != hashTwo.charAt(i))
          result += `<span style='color: red;'>${val}</span>`;
        else
          result += val;
      })
      return result;
    }
  },
  mounted() {
    if ('image_one' in this.$route.query) {
      this.imageOneId = this.$route.query.image_one;
      this.loadPost(this.imageOneId);
    }
    if ('image_two' in this.$route.query) {
      this.imageTwoId = this.$route.query.image_two;
      this.loadPost(this.imageTwoId);
    }
  },
  computed: {
    imageOneDif: function () {
      return this.imageOne && this.imageTwo ? this.difHashes(this.imageOne.hashes[0].hash, this.imageTwo.hashes[0].hash) : "";
    },
    imageTwoDif: function () {
      return this.imageOne && this.imageTwo ? this.difHashes(this.imageTwo.hashes[0].hash, this.imageOne.hashes[0].hash) : "";
    },
    percentDif: function () {
      if (!this.imageOne && !this.imageTwo)
        return
      let distance = hammingDistance(this.imageOne.hashes[0].hash, this.imageTwo.hashes[0].hash);
      let diff = 100 - (distance / this.imageTwo.hashes[0].hash.length * 100)
      return Math.round((diff + Number.EPSILON) * 100) / 100
    }
  },

}
</script>

<style scoped>
chardif {
  color: red;
}
</style>
